import Vue from 'vue'
// 公共CSS
import '@/assets/css/reset.css'
// 公共组件CSS
import '@/assets/css/list.css'
// 引入路由
import vueRouter from 'vue-router'
Vue.use(vueRouter);
import router from '@/router'
// 引入axios
import axios from 'axios';
Vue.prototype.axios = axios;
Vue.prototype.post = axios.post;
Vue.prototype.get = axios.get;
// 字体CSS
import '@/../static/css/font-awesome.min.css';
// Element Ui
import el from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(el);
// 修改 Dialog 默认遮罩层无法点击关闭
el.Dialog.props.closeOnClickModal.default = false;
// 引入qs
import qs from 'qs';
// 引入cookie
import cookie from 'js-cookie';
Vue.prototype.cookie = cookie;
// 空提示组件
import empty from '@/components/other/empty.vue'
Vue.component('empty', empty);
//  vuex 状态
import store from '@/store'

// 请求是否登录
function is_login() {
  var data = {
    username: cookie.get('username')
  }
  return axios.post('/admin/Index/is_login', data);
}

// 登录验证 - 路由发生变化修改页面标题
router.beforeEach((to, from, next) => {
  let state = store.state;
  // 修改页面标题和头部标题
  document.title = to.meta.title + ' - 危废管理系统软件';
  state.header.title = to.meta.title;
  // 去登录界面
  if (to.path == '/login') {
    next();
    return false;
  }
  // 不需要登录的
  if (to.meta.login != null && to.meta.login == 0) {
    next();
    return false;
  }

  // 没有登录
  if (!cookie.get('username')) {
    next('/login');
    return false;
  }
  // 当登录并且有数据时
  if (store.state.user) {
    next();
    return false;
  }
  // 登录 没有数据时
  is_login().then(res => {
    if (res.state) {
      store.state.user = res.data;
      next();
    } else {
      cookie.remove('username');
      next('/login');
    }
  })
})

// 路由全局后置钩子
router.afterEach((to, from) => {
})
// 请求拦截器
axios.interceptors.request.use(res => {
  // 序列化请求参数 
  let data = res.data;
  // 判断是否为对象 , 为了去除解决上传文件 FormData
  if (data && data.toString() == '[object Object]') {
    res.data = qs.stringify(data);
  }
  return res;
})
// 响应拦截器
axios.interceptors.response.use(res => {
  let data = res.data;
  // 当后台返回0时(代表报错提示,不是程序出错)
  if (!data.state) el.Message({ type: 'error', message: data.info });
  return res.data;
}, function (e) {
  let r = e.response;
  el.Message({ type: 'error', message: '错误 , ' + r.status + ' : ' + r.statusText });
  return { state: 0 };
})



// WEBPACK FOOTER //
// ./src/import/index.js